var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-panel"
  }, [_c('p', {
    staticClass: "left-panel-title"
  }, [_vm._v("标签类型")]), _vm._v(" "), (_vm.data.hasSecondTabs) ? _c('div', {
    staticClass: "tab-button-group tag-btn-container"
  }, _vm._l((_vm.data.secondTabs), function(item, index) {
    return _c('button', {
      staticClass: "switch-tag-btn",
      class: {
        'tab-active': index == _vm.data.activeTab
      },
      on: {
        "click": function($event) {
          _vm.handleTabClick(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "left-panel-select-box"
  }, [_c('ul', {
    staticClass: "cas-panel"
  }, _vm._l((_vm.data.secondTabs[_vm.data.activeTab].items), function(item, index) {
    return _c('li', {
      staticClass: "cas-item",
      class: {
        'tab-active': index == _vm.data.secondTabs[_vm.data.activeTab].activeIndex
      },
      on: {
        "click": function($event) {
          _vm.handleItemClick(item, index)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])
  }))])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7753f6e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SelectBoxLeftPanel.vue
// module id = 17Wg
// module chunks = 1